<template>
  <!-- 基本信息 -->
  <div style="background: #fff;">
    <div>
      <el-row >
        <el-col class="marginten">
          <img
            src="@/assets/beadhouse/juxing.png"
            style="vertical-align:middle"
          />
          <span style="vertical-align:middle;font-size:16px;margin-left:10px"
            >被申请人员基本情况</span
          >
        </el-col>
        <el-form
          style="margin-top:35px;margin-bottom:35px"
          :model="olderBaseDetailBean"
          :rules="rules"
          ref="olderBaseDetailBean"
          label-width="150px"
          class="demo-ruleForm"
        >
          <el-row>
            <el-col :span="9">
              <el-form-item prop="oldName" label="姓名">
                <el-input
                  v-model.trim="olderBaseDetailBean.oldName"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="oldIdCard" label="身份证号">
                <el-input
                  v-model.trim="olderBaseDetailBean.oldIdCard"
                  class="itemminwidth"
                  @change="changeIdCard"
                ></el-input>
              </el-form-item>
              <el-form-item prop="ssCard" label="社保账号">
                <el-input
                  v-model.trim="olderBaseDetailBean.ssCard"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="birthday" label="出生日期 ">
                <el-date-picker
                  align="bottom"
                  :editable="false"
                  :clearable="false"
                  v-model="olderBaseDetailBean.birthday"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  @change="changeBirthday"
                  class="itemminwidth"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4"> <span>带*为必填选项</span> </el-col>
            <el-col :span="11">
              <el-upload
                class="avatar-uploader"
                action="string"
                accept="image/png, image/jpeg"
                :show-file-list="false"
                list-type="picture-card"
                :before-upload="beforeAvatarUpload"
                :http-request="uploadHeadPicSectionFile"
              >
                <img v-if="headImageUrl" :src="headImageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-row class="headPic">老人头像</el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              <el-form-item prop="sex" label="性别 ">
                <el-select
                  v-model="olderBaseDetailBean.sex"
                  @change="changeSex"
                  class="itemminwidth"
                >
                  <el-option value="0" label="男"></el-option>
                  <el-option value="1" label="女"></el-option>
                </el-select>
              </el-form-item>
              <!-- 入院时间 -->
              <el-form-item label="入院时间" prop="registryTime" class="date-style">
                <el-date-picker type="date" placeholder="选择日期" class="itemminwidth"
                  value-format="yyyy-MM-dd"
                  v-model="olderBaseDetailBean.registryTime"></el-date-picker>
              </el-form-item>
              <el-form-item prop="peopleType" label="人员类别">
                <el-select
                  v-model="olderBaseDetailBean.peopleType"
                  class="itemminwidth"
                  @change="handleSelectPerson"
                >
                  <el-option
                    v-for="(item,index) in personReduceOptions"
                    :key="index"
                    :label="item.userTypeName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="oldPhone" label="老人电话">
                <el-input
                  v-model.trim="olderBaseDetailBean.oldPhone"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="mStatus" label="婚姻状况 ">
                <el-select
                  v-model="olderBaseDetailBean.mStatus"
                  class="itemminwidth"
                >
                  <el-option value="1" label="未婚"></el-option>
                  <el-option value="2" label="已婚"></el-option>
                  <el-option value="3" label="丧偶"></el-option>
                  <el-option value="4" label="离异"></el-option>
                  <el-option value="5" label="未说明婚姻状况"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="oldEctLel" label="文化程度">
                <el-select
                  v-model="olderBaseDetailBean.oldEctLel"
                  class="itemminwidth"
                >
                  <el-option value="1" label="无"></el-option>
                  <el-option value="2" label="文盲"></el-option>
                  <el-option value="3" label="小学 "></el-option>
                  <el-option value="4" label="初中"></el-option>
                  <el-option value="5" label="高中"></el-option>
                  <el-option value="6" label="大专及以上"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="religion" label="宗教信仰">
                <el-select
                  v-model="olderBaseDetailBean.religion"
                  class="itemminwidth"
                >
                  <el-option value="1" label="无"></el-option>
                  <el-option value="2" label="佛教"></el-option>
                  <el-option value="3" label="道教"></el-option>
                  <el-option value="4" label="伊斯兰"></el-option>
                  <el-option value="5" label="基督教"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="economicSource" label="主要经济来源">
                <el-select
                  v-model="olderBaseDetailBean.economicSource"
                  class="itemminwidth"
                >
                  <el-option value="1" label="无"></el-option>
                  <el-option value="2" label="低保"></el-option>
                  <el-option value="3" label="低保边缘户"></el-option>
                  <el-option value="4" label="退休金/养老金"></el-option>
                  <el-option value="5" label="子女补贴"></el-option>
                  <el-option value="6" label="亲友资助"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="15">
              <el-row>
                <el-col :span="7">
                  <el-form-item
                    prop="isDisabled"
                    style="margin-bottom:15px"
                    label="是否残疾"
                  >
                    <el-select
                      v-model="olderBaseDetailBean.isDisabled"
                      style="width:70px"
                      placeholder=""
                      @change="changeIsDisabled"
                    >
                      <el-option value="1" label="是"></el-option>
                      <el-option value="0" label="否"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="17">
                  <el-form-item
                    prop="disabledNo"
                    ref="disabledNoForm"
                    style="margin-bottom:15px"
                    label="残疾证编号"
                    label-width="100px"
                  >
                    <el-input
                      v-model="olderBaseDetailBean.disabledNo"
                      style="width:200px"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row style="margin-left:80px;width:400px">
                <el-col>
                  <span style="float:left;margin-right:15px">精神残疾</span>
                  <el-radio-group
                    v-model="olderBaseDetailBean.sdisabledLevel"
                  >
                    <el-radio :label="1">一级</el-radio>
                    <el-radio :label="2">二级</el-radio>
                    <el-radio :label="3">三级</el-radio>
                    <el-radio :label="4">四级</el-radio>
                  </el-radio-group>
                </el-col>
                <el-col>
                  <span style="float:left;margin-right:15px">肢体残疾</span>
                  <el-radio-group
                    v-model="olderBaseDetailBean.bdisabledLevel"
                  >
                    <el-radio :label="1">一级</el-radio>
                    <el-radio :label="2">二级</el-radio>
                    <el-radio :label="3">三级</el-radio>
                    <el-radio :label="4">四级</el-radio>
                  </el-radio-group>
                </el-col>
                <el-col>
                  <span style="float:left;margin-right:15px">混合残疾</span>
                  <el-radio-group
                    v-model="olderBaseDetailBean.sdDisabledLevel"
                  >
                    <el-radio :label="1">一级</el-radio>
                    <el-radio :label="2">二级</el-radio>
                    <el-radio :label="3">三级</el-radio>
                    <el-radio :label="4">四级</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
                
              <el-form-item
                prop="oldAddress"
                style="margin-top:17px"
                label="家庭住址"
              >
                <el-input
                  v-model.trim="olderBaseDetailBean.oldAddress"
                  class="itemlarwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="ancestral" label="籍贯">
                <el-input
                  v-model.trim="olderBaseDetailBean.ancestral"
                  class="itemlarwidth"
                ></el-input>
              </el-form-item>
              <el-form-item label="政治面貌" prop="political">
                <el-select
                 class="itemlarwidth"
                  v-model="olderBaseDetailBean.political"
                  placeholder="请选择">
                  <el-option label="党员" value="党员"></el-option>
                  <el-option label="群众" value="群众"></el-option>
                  <el-option label="民主党派" value="民主党派"></el-option>
                  <el-option label="无党派人士" value="无党派人士"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="ocompany" label="原工作单位 ">
                <el-input
                  v-model.trim="olderBaseDetailBean.ocompany"
                  class="itemlarwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="ocContact" label="原工作单位联系人  ">
                <el-input
                  v-model.trim="olderBaseDetailBean.ocContact"
                  class="itemlarwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="ocPhone" label="原工作单位联系方式 ">
                <el-input
                  v-model.trim="olderBaseDetailBean.ocPhone"
                  class="itemlarwidth"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col v-if="issleepy" :span="9">
              <el-form-item prop="ocommunity" label="原籍所在街道社区 ">
                <el-input
                  v-model.trim="olderBaseDetailBean.ocommunity"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="relativePhone" label="亲属联系电话">
                <el-input
                  v-model.trim="olderBaseDetailBean.relativePhone"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="isKeepAshes" label="是否保留骨灰">
                <el-select
                  v-model="olderBaseDetailBean.isKeepAshes"
                  class="itemminwidth"
                >
                  <el-option value label="请选择"></el-option>
                  <el-option value="1" label="是"></el-option>
                  <el-option value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="issleepy" :span="15">
              <el-form-item prop="ccommunity" label="现籍所在街道社区">
                <el-input
                  v-model.trim="olderBaseDetailBean.ccommunity"
                  class="itemlarwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="ccomphone" label="现籍所在社区电话">
                <el-input
                  v-model.trim="olderBaseDetailBean.ccomphone"
                  class="itemlarwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="isDonate" label="是否遗体捐赠">
                <el-select
                  v-model="olderBaseDetailBean.isDonate"
                  class="itemlarwidth"
                >
                  <el-option value label="请选择"></el-option>
                  <el-option value="1" label="是"></el-option>
                  <el-option value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            prop="psHistory"
            label="既往病史"
            class="el-form-item__content_psHistory"
          >
            <el-checkbox-group
              v-model="olderBaseDetailBean.psHistory"
              class="height40"
            >
              <el-checkbox label="1">高血压</el-checkbox>
              <el-checkbox label="2">糖尿病</el-checkbox>
              <el-checkbox label="3">心脏病</el-checkbox>
              <el-checkbox label="4">关节炎</el-checkbox>
              <el-checkbox label="5">风湿病</el-checkbox>
              <!-- <el-checkbox label="6">冠心病</el-checkbox> -->
            </el-checkbox-group>
          </el-form-item>
          <el-form-item prop="diseaseother" label="其他" style="margin-top:5px">
            <el-input
              v-model.trim="olderBaseDetailBean.diseaseother"
              v-bind:style="{ width: bigWidth + 'px' }"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 4 }"
              maxlength="128"
              resize="none"
            ></el-input>
          </el-form-item>

          <el-form-item
            prop="specialDiet"
            label="特殊饮食要求"
            class="el-form-item__content_specialDiet"
          >
            <el-checkbox-group
              v-model="olderBaseDetailBean.specialDiet"
              class="height40"
            >
              <el-checkbox label="1">低盐</el-checkbox>
              <el-checkbox label="2">低脂</el-checkbox>
              <el-checkbox label="3">低糖</el-checkbox>
              <el-checkbox label="4">低嘌呤</el-checkbox>
              <el-checkbox label="5">流食</el-checkbox>
              <el-checkbox label="6">斋食</el-checkbox>
              <el-checkbox label="7">清真食</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item prop="otherDiet" label="其他" style="margin-top:5px">
            <el-input
              v-model.trim="olderBaseDetailBean.otherDiet"
              v-bind:style="{ width: bigWidth + 'px' }"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 4 }"
              maxlength="128"
              resize="none"
            ></el-input>
          </el-form-item>

          <el-form-item
            prop="dhistory"
            label="药物过敏史"
            style="margin-top:5px"
          >
            <el-input
              v-model.trim="olderBaseDetailBean.dhistory"
              v-bind:style="{ width: bigWidth + 'px' }"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 4 }"
              maxlength="128"
              resize="none"
            ></el-input>
          </el-form-item>

          <!-- 申请人情况 -->
          <el-col v-if="!issleepy" class="marginten">
            <img
              src="@/assets/beadhouse/juxing.png"
              style="vertical-align:middle"
            />
            <span style="vertical-align:middle;font-size:16px;margin-left:10px"
              >申请人情况</span
            >
          </el-col>
          <el-row>
            <el-col :span="9" v-if="!issleepy">
              <el-form-item prop="egNamea" label="姓名">
                <el-input
                  v-model.trim="olderBaseDetailBean.egNamea"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="egaIdCard" label="身份证号">
                <el-input
                  v-model.trim="olderBaseDetailBean.egaIdCard"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="email" label="联系人邮箱">
                <el-input
                  v-model.trim="olderBaseDetailBean.email"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="egCompany" label="工作单位">
                <el-input
                  v-model.trim="olderBaseDetailBean.egCompany"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="egNameb" label="备用联系人">
                <el-input
                  v-model.trim="olderBaseDetailBean.egNameb"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="anContactB" label="备用联系人">
                <el-input
                  v-model.trim="olderBaseDetailBean.anContactB"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="15" v-if="!issleepy">
              <el-form-item prop="egSex" label="性别 ">
                <el-select
                  v-model="olderBaseDetailBean.egSex"
                  class="itemminwidth"
                >
                  <el-option value label="请选择"></el-option>
                  <el-option value="0" label="男"></el-option>
                  <el-option value="1" label="女"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="relationshipa" label="与休养人关系  ">
                <el-select
                  v-model="olderBaseDetailBean.relationshipa"
                  class="itemminwidth"
                >
                  <el-option value label="请选择"></el-option>
                  <el-option value="6" label="夫妻"></el-option>
                  <el-option value="1" label="子女"></el-option>
                  <el-option value="2" label="兄弟姐妹"></el-option>
                  <el-option value="3" label="旁系亲属 "></el-option>
                  <el-option value="4" label="朋友"></el-option>
                  <el-option value="5" label="其他"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="egaAddress" label="地址 ">
                <el-input
                  v-model.trim="olderBaseDetailBean.egaAddress"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>

              <el-form-item prop="egPhonea" label="联系电话">
                <el-input
                  v-model.trim="olderBaseDetailBean.egPhonea"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="egPhoneb" label="联系电话">
                <el-input
                  v-model.trim="olderBaseDetailBean.egPhoneb"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
              <el-form-item prop="anPhoneB" label="联系电话">
                <el-input
                  v-model.trim="olderBaseDetailBean.anPhoneB"
                  class="itemminwidth"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 特殊说明 -->
          <el-row>
            <el-col :span="24" class="marginten">
              <img
                src="@/assets/beadhouse/juxing.png"
                style="vertical-align:middle"
              />
              <span
                style="vertical-align:middle;font-size:16px;margin-left:10px;"
                >特殊说明</span
              >
            </el-col>
          </el-row>
          <el-row class="judgement">
            <el-col :span="24">
              <el-form-item
                prop="outactivity"
                label="同意休养人员独立外出活动"
                label-width="300px"
                label-position="left"
              >
                <el-radio-group
                  v-model="olderBaseDetailBean.outactivity"
                  class="radiogroup"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                prop="room"
                label="是否将休养人员限制在床上或者房内"
                label-width="300px"
                label-position="left"
              >
                <el-radio-group
                  v-model="olderBaseDetailBean.room"
                  class="radiogroup"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                prop="isHospitol"
                label="休养人紧急情况下是否允许院方诊治"
                label-width="300px"
                label-position="left"
              >
                <el-radio-group
                  v-model="olderBaseDetailBean.isHospitol"
                  class="radiogroup"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="2">生病通知</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                prop="dissother"
                label="夜间是否吵闹干扰他人"
                label-width="300px"
                label-position="left"
              >
                <el-radio-group
                  v-model="olderBaseDetailBean.dissother"
                  class="radiogroup"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="marginten">
              <img
                src="@/assets/beadhouse/juxing.png"
                style="vertical-align:middle"
              />
              <span
                style="vertical-align:middle;font-size:16px;margin-left:10px;"
                >身份证截图</span
              >
            </el-col>
            <el-col :offset="1" :span="22">
              <el-upload
                action="string"
                accept="image/png, image/jpeg"
                list-type="picture-card"
                :file-list="idCardFileList"
                :before-upload="beforeAvatarUploadPicA"
                :http-request="uploadSectionFilePicA"
                :on-preview="handlePictureCardPreviewPicA"
                :on-remove="handleRemovePicA"
                ref="imagePicA"
                :limit="100"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog title="身份证截图" :visible.sync="dialogVisibleIdCard">
                <el-image
                  class="elImage"
                  fit="fill"
                  :src="dialogImageUrlIdCardPic"
                  preview="1"
                ></el-image>
              </el-dialog>
            </el-col>
            <el-col class="marginten">
              <img
                src="@/assets/beadhouse/juxing.png"
                style="vertical-align:middle"
              />
              <span
                style="vertical-align:middle;font-size:16px;margin-left:10px;"
                >出院小结截图</span
              >
            </el-col>

            <el-col :offset="1" :span="22">
              <el-upload
                action="string"
                accept="image/png, image/jpeg"
                list-type="picture-card"
                :file-list="outFileList"
                :before-upload="beforeAvatarUploadPicB"
                :http-request="uploadSectionFilePicB"
                :on-preview="handlePictureCardPreviewPicB"
                :on-remove="handleRemovePicB"
                :limit="100"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog title="出院小结截图" :visible.sync="dialogVisibleOut">
                <el-image
                  class="elImage"
                  fit="fill"
                  :src="dialogImageUrlOutPic"
                  preview="1"
                ></el-image>
              </el-dialog>
            </el-col>

            <el-col class="marginten">
              <img
                src="@/assets/beadhouse/juxing.png"
                style="vertical-align:middle"
              />
              <span
                style="vertical-align:middle;font-size:16px;margin-left:10px;"
                >其他截图</span
              >
            </el-col>

            <el-col :offset="1" :span="22">
              <el-upload
                action="string"
                accept="image/png, image/jpeg"
                list-type="picture-card"
                :file-list="otherFileList"
                :before-upload="beforeAvatarUploadPicC"
                :http-request="uploadSectionFilePicC"
                :on-preview="handlePictureCardPreviewPicC"
                :on-remove="handleRemovePicC"
                :limit="100"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog title="其他截图" :visible.sync="dialogVisibleOther">
                <el-image
                  class="elImage"
                  fit="fill"
                  :src="dialogImageUrlOtherPic"
                  preview="1"
                ></el-image>
              </el-dialog>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
    </div>
    <div slot="footer" class="footer" align="center">
      <el-button type="warning" plain @click="back">返回</el-button>
      <el-button type="primary" plain @click="submitData" :loading="addLoading"
        >下一步</el-button
      >
    </div>
  </div>
</template>
<script>
import util from "@/utils/util.js";
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "OlderDetailBase",
  data() {
    var validateOldId = (rule, value, callback) => {
      if (!value) {
        if (rule.field == "oldIdCard" || rule.field == "egaIdCard") {
          return callback(new Error("老人身份证号不能为空"));
        } else {
          return callback(new Error("老人社保账号不能为空"));
        }
      } else {
        //by guo 2019-3-28    添加15 和18位的身份证验证年月日合法
        var re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
        //also re = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
        var arrSplit = value.match(re); //检查生日日期是否正确  18位
        var re2 = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
        var arrSplit2 = value.match(re2); //检查生日日期是否正确  15位
        if (arrSplit != null) {
          var check18 = util.formatDate.YearMonthDayValidate(
            arrSplit[2],
            arrSplit[3],
            arrSplit[4]
          );
        }
        if (arrSplit2 != null) {
          if (parseInt(arrSplit2[2].substr(1)) > 0) {
            arrSplit2[2] = "19" + arrSplit2[2];
          } else {
            arrSplit2[2] = "20" + arrSplit2[2];
          }
          var check15 = util.formatDate.YearMonthDayValidate(
            arrSplit2[2],
            arrSplit2[3],
            arrSplit2[4]
          );
        }

        //  老身份证15位  新身份证18位(最后一位可以是大写X)
        //var reg = /^(\d{15}|\d{17}[xX\d])$/
        var reg = /^(\d{15}|\d{17}[X\d])$/; //by guo 2019-11-04-17:17修改
        if (!reg.test(value)) {
          if (rule.field == "oldIdCard" || rule.field == "egaIdCard") {
            callback(new Error("请输入正确的身份证号码"));
          } else {
            callback(new Error("请输入正确的社保账号"));
          }
        } else if (check18 == false || check15 == false) {
          //by guo 2019-3-28 添加
          callback(new Error("出生日期不准确"));
        } else {
          callback();
        }
      }
    };
    //残疾编号
    var validateDisabledNo = (rule, value, callback) => {
      var reg = /(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)[1-7][1-4]$)/;
      if (
        this.disabled == true &&
        (value == "" || value == undefined || value == null)
      ) {
        callback();
      } else if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的残疾编号"));
      }
    };
    //电话号码的验证
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电话号码"));
      } else {
        // 因为现在新增了166、198、199号段的手机号
        var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
        if (!reg.test(value)) {
          callback(new Error("电话号码格式错误"));
        } else {
          callback();
        }
      }
    };
    //by guo 2019-11-26-11:46添加 校验老人姓名不能输入特殊字符
    var validateInput = (rule, value, callback) => {
      if (!this.checkSpecialKey(value)) {
        callback(new Error("老人姓名不能含有特殊字符"));
      } else {
        callback();
      }
    };
    return {
      addLoading: false, //点击下一步的加载loading
      hospitalStatus: -1, //是否入院的状态 -1--未入院  2----入院
      isPayed: "", //是否已缴费的状态  0---未缴  1---已缴
      peopleTypeDisabled: false, //人员类别的下拉框是否可以选取
      headImageUrl: "", //老人头像
      oldmanId: "", //老人id
      personReduceOptions: [], //人员类别的数据
      selectIsDisabled: false, //是否残疾的下拉框是否可以选取  默认可以选取
      disabled: true, //默认没有  是否残疾
      olderBaseDetailBean: {
        headPic: "", //头像的id
        advisoryId: "", //咨询记录id
        oldName: "", //老人姓名
        sex: "", //老人姓名
        oldPhone: "", //老人电话
        birthday: "", //老人生日
        oldIdCard: "", //老人身份证号
        oldAddress: "", //老人家庭住址
        ssCard: "", //社保账号
        mStatus: "", //婚姻状况
        peopleType: "", //人员类别
        oldEctLel: "", //文化程度
        religion: "", //宗教信仰
        economicSource: "", //经济来源
        isDisabled: "", //是否残疾
        disabledNo: "", //残疾证编号
        sdisabledLevel: "", //精神残疾
        bdisabledLevel: "", //肢体残疾
        sdDisabledLevel: "", //混合残疾
        ocompany: "", //原工作单位
        ocContact: "", //原工作单位联系人
        ocPhone: "", //原工作单位联系方式
        psHistory: [], //既往病史
        diseaseother: "", //既往病史其他
        specialDiet: [], //特殊饮食要求
        otherDiet: "", //特殊饮食要求其他
        dhistory: "", //药物过敏史

        //政府特困对象才有的字段  其他类型没有的
        ocommunity: "", //原籍所在街道社区
        relativePhone: "", //亲属联系电话
        isKeepAshes: "", //是否保留骨灰
        ccommunity: "", //现籍所在街道社区
        ccomphone: "", // 现籍所在社区电话
        isDonate: "", //是否捐赠

        //申请人信息  政府特困对象没有  其他类型才有的
        egNamea: "", //申请人姓名
        egaIdCard: "", //申请人身份证号
        email: "", //邮箱
        egCompany: "", //工作单位
        egNameb: "", //备用联系人a
        anContactB: "", //备用联系人b
        egSex: "", //申请人性别
        relationshipa: "", //与老人关系
        egaAddress: "", //地址
        //egPhone:"", //申请人电话
        egPhonea: "", //紧急联系人a
        egPhoneb: "", //紧急联系人b
        anPhoneB: "", //备用联系人b
        //特殊说明
        outactivity: "", //同意休养人员独立外出活动

        //身份证截图
        idCardPic: [],
        //出院小结截图
        outPic: [],
        //其他截图
        otherPic: []
      },
      idCardPicList: [], //身份证截图储存的数组
      outPicList: [], //出院小结截图储存的数组
      otherPicList: [], //其他截图储存的数组

      idCardFileList: [], //身份证截图回显的数据
      outFileList: [], //出院小结截图回显的数据
      otherFileList: [], //其他截图回显的数据

      dialogVisibleIdCard: false,
      dialogImageUrlIdCardPic: "", //身份证的dialog图
      dialogVisibleOut: false,
      dialogImageUrlOutPic: "", //出院小结dialog图
      dialogVisibleOther: false,
      dialogImageUrlOtherPic: "", //其他截图dialog图

      rules: {
        //被申请人校验
        oldName: [
          { required: true, message: "请输入老人姓名", trigger: "blur" },
          { required: true, validator: validateInput, trigger: "blur" }, //by guo 2019-11-26-11:46修改
          { min: 1, max: 10, message: "长度在 1到 10 位的字符" }
        ],
        oldIdCard: [
          { required: true, validator: validateOldId, trigger: "blur" }
        ],
        // ssCard: [{ required: true, validator: validateOldId, trigger: "blur" }],
        birthday: [
          { required: true, message: "请选择老人出生日期", trigger: "change" }
        ],
        sex: [{ required: true, message: "请选择老人性别", trigger: "change" }],
        registryTime: [
          { required: true, message: "请选择入院时间", trigger: "change" }
        ],
        peopleType: [
          { required: true, message: "请选择类别", trigger: "change" }
        ],
        oldAddress: [
          { required: true, message: "请输入家庭住址", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1到 50 位的字符" }
        ],
        ocompany: [{ min: 0, max: 25, message: "长度在 0到 25 位的字符" }], //原工作单位
        ocContact: [{ min: 0, max: 10, message: "长度在 0到 10 位的字符" }], //原工作单位联系人
        ocPhone: [
          { pattern: /^[0-9]+$/, message: "请输入由数字组成的字符" },
          { min: 0, max: 12, message: "长度在 0到 12 位的数字" }
        ], //原工作单位联系方式
        diseaseother: [
          { min: 0, max: 100, message: "长度在 0到 100 位的字符" }
        ], //既往病史
        otherDiet: [{ min: 0, max: 100, message: "长度在 0到 100 位的字符" }], //特殊饮食要求其他
        dhistor: [{ min: 0, max: 100, message: "长度在 0到 100 位的字符" }], //药物过敏史
        //申请人校验
        egNamea: [
          { required: true, message: "请输入申请人姓名", trigger: "blur" },
          { min: 1, max: 10, message: "长度在 1到 10 位的字符" }
        ],
        // egSex: [{ required: true, message: "请选择性别", trigger: "change" }],
        egaIdCard: [
          {
            pattern: /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/,
            message: "请输入正确的身份证号码"
          }
        ],
        egaAddress: [
          // { required: true, message: "请输入地址", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1到 50 位的字符" }
        ],
        //egPhonea:[{ required: true, validator:validatePhone, trigger: "blur" }],
        // egPhonea: [
        //   { required: true, message: "不能为空", trigger: "blur" },
        //   {
        //     pattern: /^1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[35678]\d{2}|4(?:0\d|1[0-2]|9\d))|9[189]\d{2}|66\d{2})\d{6}$/,
        //     message: "请输入正确的手机号格式"
        //   }
        // ],
        // egPhone:[{ required: true,  validator:validatePhone, trigger: "blur" }],
        // relationshipa: [
        //   { required: true, message: "请选择与老人的关系", trigger: "change" }
        // ],
        email: [{ min: 0, max: 30, message: "长度在 0到 30 位的字符" }], //联系邮箱
        egCompany: [{ min: 0, max: 30, message: "长度在 0到 30 位的字符" }], //工作单位
        egNameb: [{ min: 0, max: 10, message: "长度在 0到 10 位的字符" }], //备用联系人
        anContactB: [{ min: 0, max: 10, message: "长度在 0到 10 位的字符" }], //备用联系人
        egPhoneb: [
          {
            pattern: /^[0-9]+$/,
            message: "请输入正确的手机号格式"
          }
        ],
        anPhoneB: [
          {
            pattern: /^[0-9]+$/,
            message: "请输入正确的手机号格式"
          }
        ],
      },
      imageUrl: "",
      issleepy: false, //是否是三无老人
      bigWidth: 600, //根据屏幕宽度得出的 长 div宽度
      userTypeNameText: "" //人员类别判断  显示的页面  一些必填字段（申请人情况）被隐藏了  也需要提交默认值   为了兼容社区版的
    };
  },
  methods: {
    /*
      上传头像
    */
    uploadHeadPicSectionFile(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("opc/file/uploadFile", form).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.olderBaseDetailBean.headPic = res.result; //添加图片的id
            this.getImgInfo(this.olderBaseDetailBean.headPic);
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },

    /*
      上传老人头像 以及验证
    */
    beforeAvatarUpload(file) {
      let isPNG = false;
      let isImage = false; //by guo 2020-6-30-16:08添加
      file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
      isImage = file.type.match("image") != "image" ? false : true;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error("上传图片格式错误");
      }
      if (!isPNG) {
        this.$message.error("上传图片格式不能是 gif 格式");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB");
      }
      return isPNG && isLt2M && isImage;
    },

    /*
      身份证截图
    */
    uploadSectionFilePicA(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("opc/file/uploadFile", form).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.olderBaseDetailBean.idCardPic.push(res.result); //添加图片的id
            this.idCardPicList.forEach(item => {
              //添加数组中 上传之前的图片数组 用于删除的时候去比较
              if (item.id == null) {
                item.id = res.result;
              }
            });
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },

    //删除身份证截图
    handleRemovePicA(file, fileList) {
      //分两类删除  一类是还未提交上传基本信息的   二类是已经提交上传基本信息的
      if (file.status == "ready") {
        //删除的是一类
        for (let i = 0; i < this.idCardPicList.length; i++) {
          if (file.uid == this.idCardPicList[i].uid) {
            this.idCardPicList.splice(i, 1);
          }
        }
        for (let j = 0; j < this.olderBaseDetailBean.idCardPic.length; j++) {
          if (file.raw.id == this.olderBaseDetailBean.idCardPic[j]) {
            this.olderBaseDetailBean.idCardPic.splice(j, 1);
          }
        }
      } else if ((file.status = "success")) {
        //删除的是二类
        for (let k = 0; k < this.idCardFileList.length; k++) {
          if (file.url == this.idCardFileList[k].url) {
            this.idCardFileList.splice(k, 1);
          }
        }
        for (let m = 0; m < this.olderBaseDetailBean.idCardPic.length; m++) {
          if (file.id == this.olderBaseDetailBean.idCardPic[m]) {
            this.olderBaseDetailBean.idCardPic.splice(m, 1);
          }
        }
      }
    },

    /*
      身份证截图的验证和取值
    */
    beforeAvatarUploadPicA(file) {
      //this.idCardPicList.push(file);//获取值，用于删除时的比对  by guo 2020-6-30-16:10注释  换到下面判断才能添加
      let isPNG = false;
      let isImage = false; //by guo 2020-6-30-16:10添加
      file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
      isImage = file.type.match("image") != "image" ? false : true;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error("上传图片格式错误");
      }
      if (!isPNG) {
        this.$message.error("上传图片格式不能是 gif 格式");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB");
      }
      //by guo 2020-6-30-16:12添加判断  当所有验证通过之后才将该图片添加进数组中
      if (isPNG && isLt2M && isImage) {
        this.idCardPicList.push(file);
      }
      return isPNG && isLt2M && isImage;
    },

    /*
      身份证截图放大
    */
    handlePictureCardPreviewPicA(file) {
      this.dialogVisibleIdCard = true;
      this.dialogImageUrlIdCardPic = file.url;
    },

    /*
      出院小结截图
    */
    uploadSectionFilePicB(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("opc/file/uploadFile", form).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.olderBaseDetailBean.outPic.push(res.result); //添加图片的id
            this.outPicList.forEach(item => {
              //添加数组中 上传之前的图片数组 用于删除的时候去比较
              if (item.id == null) {
                item.id = res.result;
              }
            });
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },

    /*
      删除出院小结截图
    */
    handleRemovePicB(file, fileList) {
      //分两类删除  一类是还未提交上传基本信息的   二类是已经提交上传基本信息的
      if (file.status == "ready") {
        //删除的是一类
        for (let i = 0; i < this.outPicList.length; i++) {
          if (file.uid == this.outPicList[i].uid) {
            this.outPicList.splice(i, 1);
          }
        }
        for (let j = 0; j < this.olderBaseDetailBean.outPic.length; j++) {
          if (file.raw.id == this.olderBaseDetailBean.outPic[j]) {
            this.olderBaseDetailBean.outPic.splice(j, 1);
          }
        }
      } else if ((file.status = "success")) {
        //删除的是二类
        for (let k = 0; k < this.outFileList.length; k++) {
          if (file.url == this.outFileList[k].url) {
            this.outFileList.splice(k, 1);
          }
        }
        for (let m = 0; m < this.olderBaseDetailBean.outPic.length; m++) {
          if (file.id == this.olderBaseDetailBean.outPic[m]) {
            this.olderBaseDetailBean.outPic.splice(m, 1);
          }
        }
      }
    },

    /*
      出院小结的验证和取值
    */
    beforeAvatarUploadPicB(file) {
      //this.outPicList.push(file);//获取值，用于删除时的比对  by guo 2020-6-30-16:10注释  换到下面判断才能添加
      let isPNG = false;
      let isImage = false;
      file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
      isImage = file.type.match("image") != "image" ? false : true;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error("上传图片格式错误");
      }
      if (!isPNG) {
        this.$message.error("上传图片格式不能是 gif 格式");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB");
      }
      //by guo 2020-6-30-16:12添加判断  当所有验证通过之后才将该图片添加进数组中
      if (isPNG && isLt2M && isImage) {
        this.outPicList.push(file);
      }
      return isPNG && isLt2M && isImage;
    },

    /*
      出院小结截图放大
    */
    handlePictureCardPreviewPicB(file) {
      this.dialogVisibleOut = true;
      this.dialogImageUrlOutPic = file.url;
    },

    /*
      其他截图
    */
    uploadSectionFilePicC(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("opc/file/uploadFile", form).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.olderBaseDetailBean.otherPic.push(res.result); //添加图片的id
            this.otherPicList.forEach(item => {
              //添加数组中 上传之前的图片数组 用于删除的时候去比较
              if (item.id == null) {
                item.id = res.result;
              }
            });
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },

    /*
      删除其他截图
    */
    handleRemovePicC(file, fileList) {
      //分两类删除  一类是还未提交上传基本信息的   二类是已经提交上传基本信息的
      if (file.status == "ready") {
        //删除的是一类
        for (let i = 0; i < this.otherPicList.length; i++) {
          if (file.uid == this.otherPicList[i].uid) {
            this.otherPicList.splice(i, 1);
          }
        }
        for (let j = 0; j < this.olderBaseDetailBean.otherPic.length; j++) {
          if (file.raw.id == this.olderBaseDetailBean.otherPic[j]) {
            this.olderBaseDetailBean.otherPic.splice(j, 1);
          }
        }
      } else if ((file.status = "success")) {
        //删除的是二类
        for (let k = 0; k < this.otherFileList.length; k++) {
          if (file.url == this.otherFileList[k].url) {
            this.otherFileList.splice(k, 1);
          }
        }
        for (let m = 0; m < this.olderBaseDetailBean.otherPic.length; m++) {
          if (file.id == this.olderBaseDetailBean.otherPic[m]) {
            this.olderBaseDetailBean.otherPic.splice(m, 1);
          }
        }
      }
    },

    /*
      其他截图的验证和取值
    */
    beforeAvatarUploadPicC(file) {
      let isPNG = false;
      let isImage = false;
      file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
      isImage = file.type.match("image") != "image" ? false : true;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error("上传图片格式错误");
      }
      if (!isPNG) {
        this.$message.error("上传图片格式不能是 gif 格式");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB");
      }
      //by guo 2020-6-30-16:12添加判断  当所有验证通过之后才将该图片添加进数组中
      if (isPNG && isLt2M && isImage) {
        this.otherPicList.push(file);
      }
      return isPNG && isLt2M && isImage;
    },

    /*
      其他截图放大
    */
    handlePictureCardPreviewPicC(file) {
      this.dialogVisibleOther = true;
      this.dialogImageUrlOtherPic = file.url;
    },

    /*
      头像的回显
    */
    getImgInfo(picId) {
      let id = picId;
      if (id) {
        this.srcList = [];
        this.$postForm("opc/file/queryAttachmentById/" + id).then(res => {
          var path = res.result.path;
          var name = res.result.name;
          // this.headImageUrl="http://51cs8.com/" + path + name;// by guo 2019-12-24-14:39注释
          //by guo 2019-12-24-14:39 修改  为了解决数据迁移图片回显错误的问题  因此在这里需要去判断图片是从那个图片资源服务器去拿的数据
          //因为原来武昌福利院的图片存在http://scun-yun-oos1.oss-cn-shanghai.aliyuncs.com/的path为nursing/pic/ 而平移之后的图片是存在http://51cs8.com/的path为cmny/file/
          if (path == "nursing/pic/") {
            this.headImageUrl =
              "http://scun-yun-oos1.oss-cn-shanghai.aliyuncs.com/" +
              path +
              name;
          } else {
            this.headImageUrl = "http://51cs8.com/" + path + name;
          }
        });
      }
    },

    /*
     *idList传入的图片id数组
     *type 类型  type=1---身份证截图   type=2------出院小结截图   type=3---------其他截图
     * 多张图片的的回显
     */
    getMultiImgInfo(idList, type) {
      //by guo 2019-11-25-19:20添加  清空数据，防止数据累加
      this.idCardFileList = [];
      this.outFileList = [];
      this.otherFileList = [];
      idList.forEach(item => {
        if (item != "" && item != undefined && item != null) {
          let id = item;
          this.$postForm("opc/file/queryAttachmentById/" + id).then(res => {
            var path = res.result.path;
            var name = res.result.name;
            switch (type) {
              case 1:
                // this.idCardFileList.push({id:id,name:name,url:"http://51cs8.com/" + path + name,});//身份证  by guo 2019-12-24-14:39注释
                //by guo 2019-12-24-14:39 修改  为了解决数据迁移图片回显错误的问题  因此在这里需要去判断图片是从那个图片资源服务器去拿的数据
                //因为原来武昌福利院的图片存在http://scun-yun-oos1.oss-cn-shanghai.aliyuncs.com/的path为nursing/pic/ 而平移之后的图片是存在http://51cs8.com/的path为cmny/file/
                if (path == "nursing/pic/") {
                  this.idCardFileList.push({
                    id: id,
                    name: name,
                    url:
                      "http://scun-yun-oos1.oss-cn-shanghai.aliyuncs.com/" +
                      path +
                      name
                  }); //身份证
                } else {
                  this.idCardFileList.push({
                    id: id,
                    name: name,
                    url: "http://51cs8.com/" + path + name
                  }); //身份证
                }
                break;
              case 2:
                // this.outFileList.push({id:id,name:name,url:"http://51cs8.com/" + path + name,});//出院小结 by guo 2019-12-24-14:39注释
                //by guo 2019-12-24-14:39 修改 原因同身份证截图的
                if (path == "nursing/pic/") {
                  this.outFileList.push({
                    id: id,
                    name: name,
                    url:
                      "http://scun-yun-oos1.oss-cn-shanghai.aliyuncs.com/" +
                      path +
                      name
                  }); //出院小结
                } else {
                  this.outFileList.push({
                    id: id,
                    name: name,
                    url: "http://51cs8.com/" + path + name
                  }); //出院小结
                }
                break;
              default:
                // this.otherFileList.push({id:id,name:name,url:"http://51cs8.com/" + path + name,});//其他 by guo 2019-12-24-14:39注释
                //by guo 2019-12-24-14:39 修改 原因同身份证截图的
                if (path == "nursing/pic/") {
                  this.otherFileList.push({
                    id: id,
                    name: name,
                    url:
                      "http://scun-yun-oos1.oss-cn-shanghai.aliyuncs.com/" +
                      path +
                      name
                  }); //其他
                } else {
                  this.otherFileList.push({
                    id: id,
                    name: name,
                    url: "http://51cs8.com/" + path + name
                  }); //其他
                }
                break;
            }
          });
        }
      });
    },

    /*
      是否残疾  是 下面的残疾等级可以选择和残疾编号可以说输入  否就不能
    */
    changeIsDisabled(val) {
      this.disabled = val == 0 ? true : false;
      if (val == 0) {
        this.olderBaseDetailBean.disabledNo = ""; //将残疾编号置空数据
        this.olderBaseDetailBean.sdisabledLevel = ""; //将精神残疾置空
        this.olderBaseDetailBean.bdisabledLevel = ""; //将肢体残疾置空
        this.olderBaseDetailBean.sdDisabledLevel = ""; //将混合残疾置空
        this.$refs["disabledNoForm"].clearValidate(); // 清除残疾编号的的验证
      }
    },

    //新增和修改老人时 身份证改变时触发
    changeIdCard(val) {
      if (val.length == 15) {
        var re2 = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
        var arrSplit2 = val.match(re2); //检查生日日期是否正确  15位
        var strIdCard = val.substring(14, val.length);
        var birthday =
          19 +
          val.substring(6, 8) +
          "-" +
          val.substring(8, 10) +
          "-" +
          val.substring(10, 12);
        if (arrSplit2 != null) {
          if (parseInt(arrSplit2[2].substr(1)) > 0) {
            arrSplit2[2] = "19" + arrSplit2[2];
          } else {
            arrSplit2[2] = "20" + arrSplit2[2];
          }
          var check15 = util.formatDate.YearMonthDayValidate(
            arrSplit2[2],
            arrSplit2[3],
            arrSplit2[4]
          );
        }
        if (check15) {
          this.olderBaseDetailBean.birthday = birthday;
          this.$refs["olderBaseDetailBean"].clearValidate();
        } else {
          this.olderBaseDetailBean.sex = "";
          this.olderBaseDetailBean.birthday = "";
        }
        if (strIdCard % 2 == 0) {
          this.olderBaseDetailBean.sex = "1";
        } else {
          this.olderBaseDetailBean.sex = "0";
        }
      } else if (val.length == 18) {
        var re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
        //also re = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
        var arrSplit = val.match(re); //检查生日日期是否正确  18位
        var newStrIdCard = val.substring(16, 17);
        var newbirthday =
          val.substring(6, 10) +
          "-" +
          val.substring(10, 12) +
          "-" +
          val.substring(12, 14);
        if (arrSplit != null) {
          var check18 = util.formatDate.YearMonthDayValidate(
            arrSplit[2],
            arrSplit[3],
            arrSplit[4]
          );
        }
        if (check18) {
          this.olderBaseDetailBean.birthday = newbirthday;
          this.$refs["olderBaseDetailBean"].clearValidate();
        } else {
          this.olderBaseDetailBean.sex = "";
          this.olderBaseDetailBean.birthday = "";
        }
        if (newStrIdCard % 2 == 0) {
          this.olderBaseDetailBean.sex = "1";
        } else {
          this.olderBaseDetailBean.sex = "0";
        }
      } else {
        this.olderBaseDetailBean.sex = "";
        this.olderBaseDetailBean.birthday = "";
      }
      this.olderBaseDetailBean.ssCard = val;
      this.queryIdCardRepet(val);
    },

    /*
      查询老人身份证是否已经存在
    */
    queryIdCardRepet(oldIdCard) {
      let params = new Object();
      params.oldIdCard = oldIdCard;
      this.$postJson("omc/Oldman/queryIdCardRepet", params).then(res => {
        if (res.code == 200) {
          if (res.result.result == true && res.result.oldManId != null) {
            var hospitalType = sessionStorage.getItem("hospitalType");
            if (hospitalType == 1) {
              this.$confirm(
                "老人身份证已经存在,是否回显老人基本信息?",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  center: true
                }
              )
                .then(() => {
                  this.selectOldManSupByOld(res.result.oldManId);
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消"
                  });
                });
            } else {
              // this.$message({message:"该身份证已经存在",type:"error"});
            }
          }
        }
      });
    },

    /*
      新增和修改老人时 选取性别
    */
    changeSex(val) {
      this.olderBaseDetailBean.sex = val;
    },
    /*
      新增和修改老人时 选取生日
    */
    changeBirthday(val) {
      this.olderBaseDetailBean.birthday = util.formatDate.format(
        new Date(val),
        "yyyy-MM-dd"
      );
    },

    /*
      提交form表单数据
      这里需要分三种情况:
      * 一.从入院咨询跳转过来的提交数据需要咨询id  advisoryId，不需要老人id oldmanId
      *二.从入院办理列表添加按钮跳转过来不需要advisoryId，也不需要老人oldmanId
      *三.从入院办理列表修改按钮跳转过来的不需要advisoryId，需要oldmanId
    */
    submitData() {
      let that = this;
      this.$refs.olderBaseDetailBean.validate(valid => {
        if (valid) {
         
          var params = new Object();
          params = Object.assign({}, that.olderBaseDetailBean); //拷贝对象
          //人员类别是政府供养特困对象时  因为页面的申请人情况隐藏了  为了接口兼容社区版  所以也需要提交一个默认的字段给后端
          if (that.userTypeNameText == "政府供养特困对象") {
            if (that.oldmanId == null) {
              params.egNamea = null;
              params.egSex = null;
              params.egaIdCard = null;
              params.egaAddress = null;
              params.egPhonea = null;
              params.relationshipa = null;
            }
          }
          //既往病史
          var chronicDis = "";
          if (that.olderBaseDetailBean.psHistory.indexOf("1") != -1) {
            chronicDis = "1";
          } else {
            chronicDis = "0";
          }
          if (that.olderBaseDetailBean.psHistory.indexOf("2") != -1) {
            chronicDis = chronicDis + "-1";
          } else {
            chronicDis = chronicDis + "-0";
          }
          if (that.olderBaseDetailBean.psHistory.indexOf("3") != -1) {
            chronicDis = chronicDis + "-1";
          } else {
            chronicDis = chronicDis + "-0";
          }
          if (that.olderBaseDetailBean.psHistory.indexOf("4") != -1) {
            chronicDis = chronicDis + "-1";
          } else {
            chronicDis = chronicDis + "-0";
          }
          if (that.olderBaseDetailBean.psHistory.indexOf("5") != -1) {
            chronicDis = chronicDis + "-1";
          } else {
            chronicDis = chronicDis + "-0";
          }
          // if (this.olderBaseDetailBean.psHistory.indexOf("6") != -1) {
          //   chronicDis = chronicDis + "-1";
          // } else {
          //   chronicDis = chronicDis + "-0";
          // }
          // if (this.olderBaseDetailBean.psHistory.indexOf("7") != -1) {
          //   chronicDis = chronicDis + "-1";
          // } else {
          //   chronicDis = chronicDis + "-0";
          // }
          //既往病史其他 diseaseother
          if (
            that.olderBaseDetailBean.diseaseother != "" &&
            that.olderBaseDetailBean.diseaseother != undefined &&
            that.olderBaseDetailBean.diseaseother != null
          ) {
            params.psHistory =
              chronicDis + "-" + that.olderBaseDetailBean.diseaseother;
          } else {
            params.psHistory = chronicDis + "-" + "";
          }
          //特殊饮食要求
          var specialDiet = "";
          if (that.olderBaseDetailBean.specialDiet.indexOf("1") != -1) {
            specialDiet = "1";
          } else {
            specialDiet = "0";
          }
          if (that.olderBaseDetailBean.specialDiet.indexOf("2") != -1) {
            specialDiet = specialDiet + "-1";
          } else {
            specialDiet = specialDiet + "-0";
          }
          if (that.olderBaseDetailBean.specialDiet.indexOf("3") != -1) {
            specialDiet = specialDiet + "-1";
          } else {
            specialDiet = specialDiet + "-0";
          }
          if (that.olderBaseDetailBean.specialDiet.indexOf("4") != -1) {
            specialDiet = specialDiet + "-1";
          } else {
            specialDiet = specialDiet + "-0";
          }
          if (that.olderBaseDetailBean.specialDiet.indexOf("5") != -1) {
            specialDiet = specialDiet + "-1";
          } else {
            specialDiet = specialDiet + "-0";
          }
          if (that.olderBaseDetailBean.specialDiet.indexOf("6") != -1) {
            specialDiet = specialDiet + "-1";
          } else {
            specialDiet = specialDiet + "-0";
          }
          if (that.olderBaseDetailBean.specialDiet.indexOf("7") != -1) {
            specialDiet = specialDiet + "-1";
          } else {
            specialDiet = specialDiet + "-0";
          }
          if (
            that.olderBaseDetailBean.otherDiet != "" &&
            that.olderBaseDetailBean.otherDiet != undefined &&
            that.olderBaseDetailBean.otherDiet != null
          ) {
            params.specialDiet =
              specialDiet + "-" + that.olderBaseDetailBean.otherDiet;
          } else {
            params.specialDiet = specialDiet + "-" + "";
          }
          //特殊说明
          params.specialCase =
            (that.olderBaseDetailBean.outactivity==undefined?' ':that.olderBaseDetailBean.outactivity) +
            "-" +
            (that.olderBaseDetailBean.room==undefined?' ':that.olderBaseDetailBean.room) +
            "-" +
            (that.olderBaseDetailBean.isHospitol==undefined?' ':that.olderBaseDetailBean.isHospitol) +
            "-" +
            (that.olderBaseDetailBean.dissother==undefined?' ':that.olderBaseDetailBean.dissother);
          //that
          if (this.olderBaseDetailBean.advisoryId != undefined || "" || null) {
            params.advisoryId = that.olderBaseDetailBean.advisoryId;
          }
          that.compactObj(params, that.isEmpty); //调用方法  过滤掉 '' null undefined 的数据
          delete params.diseaseother; //去除不需要的字段
          delete params.otherDiet; //去除不需要的字段
          delete params.createTime; //去除不需要的字段
          delete params.status; //去除不需要的字段
          delete params.userName; //去除不需要的字段
          delete params.valid; //去除不需要的字段
          delete params.height; //去除不需要的字段
          delete params.inDepositStatus;
          delete params.inEpositNo;
          delete params.isPayed;
          delete params.modifier;
          delete params.modifyTime;
          delete params.oldAddressBdGps;
          delete params.oldAge;
          delete params.oldmanNo;
          delete params.outactivity;
          delete params.room;
          delete params.isHospitol;
          delete params.dissother;
          //身份证截图
          if (that.olderBaseDetailBean.idCardPic.length > 0) {
            params.idCardPic = that.olderBaseDetailBean.idCardPic.join(",");
          } else {
            params.idCardPic = "";
          }
          //出院小结截图
          if (that.olderBaseDetailBean.outPic.length > 0) {
            params.outPic = that.olderBaseDetailBean.outPic.join(",");
          } else {
            params.outPic = "";
          }
          //其他截图
          if (that.olderBaseDetailBean.otherPic.length > 0) {
            params.otherPic = that.olderBaseDetailBean.otherPic.join(
              ","
            );
          } else {
            params.otherPic = "";
          }
          params.serviceType = 1;
          console.log(params, "提交的数据");
          var url = "";
          if (that.oldmanId == null) {
            //新增
            url = "omc/Oldman/addOldmanWithSupplement";
          } else {
            //修改
            url = "omc/Oldman/updateOldmanWithSupplement";
          }
          that.addLoading = true;
          // 根据
          // params.peopleType = Number(params.peopleType)
          that.personReduceOptions.forEach(item => {
            if (item.userTypeCode == params.peopleType) {
              params.peopleType = item.id;
            }
          });

          this.$postJson(url, params).then(res => {
            if (res.code == 200) {
              this.$bus.$emit("changeStatus"); //刷新入院咨询页面  by xiang
              if (that.oldmanId != null) {
                this.queryOldmanIsEvaluate(this.oldmanId);
              } else {
                this.$alert(
                  "添加成功,但该老人没有评估记录,无法进行下一步,请先去为该老人评估",
                  "提示",
                  {
                    confirmButtonText: "确定",
                    callback: action => {
                      bus.$emit("changeOldList");
                      bus.$emit("close_current_tags");
                    }
                  }
                );
              }
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.addLoading = false;
          });
        } else {
          this.$message({ message: "请检查红色项是否填写正确", type: "error" });
        }
      });
    },

    /*
      查询老人是否已经评估
    */
    queryOldmanIsEvaluate(oldmanId) {
      bus.$emit("admissiondetail", "next");
      
    },
    /*
      返回
    */
    back() {
      bus.$emit("close_current_tags");
    },
    /*
      人员类别change事件
    */
    handleSelectPerson(value) {
      this.personReduceOptions.forEach(item => {
        if (value == item.id) {
          value = item.userTypeName;
          this.userTypeNameText = item.userTypeName; //提交的时候需要判断人员类别
        }
      });
      this.issleepy = value == "政府供养特困对象" ? true : false;
    },

    /*
      获取人员类别
    */
    queryPersonCategory() {
      let params = new Object();
      params.pageNum = 0;
      params.pageSize = 0;
      this.personReduceOptions = []; //清空数据，防止累加
      this.$postJson(
        "omc/userType/queryListWithPage",
        params
      ).then(res => {
        if (res.code == 200) {
          if (res.result.list.length > 0) {
            res.result.list.forEach(item => {
              this.personReduceOptions.push({
                userTypeName: item.userTypeName,
                id: item.id,
                userTypeCode: item.userTypeCode
              });
            });
          }else{
            this.personReduceOptions.push({
                userTypeName: "老人",
                id: 0,
                userTypeCode: 0
              });
          }
          if (this.oldmanId != null) {
            this.selectOldManSupByOld(this.oldmanId);
          }
        }
      });
    },

    /*
      form表单数据回显
    */
    selectOldManSupByOld(oldmanId) {
      let params = new Object();
      params.oldmanId = oldmanId;
      this.$postForm(
        "omc/Oldman/selectOldManSupByOld",
        params
      ).then(res => {
        this.compactObj(res.result, this.isEmpty); //调用方法  过滤掉 '' null undefined 的数据
        /* 处理回显的数据  需要把后台返回的Number类型的数据转换成String类型 */
        //性别
        res.result.sex = res.result.sex == null ? "" : String(res.result.sex);
        //婚姻
        res.result.mStatus =
          res.result.mstatus == null ? "" : String(res.result.mstatus);
        //人员类别
        res.result.peopleType =
          res.result.peopleType == null ? "" : String(res.result.peopleType);
        //文化程度
        res.result.oldEctLel =
          res.result.oldEctLel == null ? "" : String(res.result.oldEctLel);
        //宗教信仰
        res.result.religion =
          res.result.religion == null ? "" : String(res.result.religion);
        //主要经济来源
        res.result.economicSource =
          res.result.economicSource == null
            ? ""
            : String(res.result.economicSource);
        //是否残疾
        res.result.isDisabled =
          res.result.isDisabled == null ? "" : String(res.result.isDisabled);
        // this.selectIsDisabled=this.oldmanId!=null ? true :false;//判断老人id是否存在，存在就是修改页面，是不可下拉的
        // this.disabled=this.oldmanId!=null ? true : false;//判断老人id是否存在，存在就是修改页面，是不可编辑的

        // this.selectIsDisabled=params.oldmanId!=null ? true :false;//判断老人id是否存在，存在就是修改页面，是不可下拉的  by guo 2019-09-18  第一次修改
        this.selectIsDisabled =
          params.oldmanId != null && this.oldmanId != null ? true : false; //判断老人id是否存在，存在就是修改页面，是不可下拉的 by guo 2019-09-20 第二次修改
        this.disabled = params.oldmanId != null ? true : false; //判断老人id是否存在，存在就是修改页面，是不可编辑的
        //申请人性别
        res.result.egSex =
          res.result.egSex == null ? "" : String(res.result.egSex);
        //与休养人关系
        res.result.relationshipa =
          res.result.relationshipa == null
            ? ""
            : String(res.result.relationshipa);
        //是否保留骨灰
        res.result.isKeepAshes =
          res.result.isKeepAshes == null ? "" : String(res.result.isKeepAshes);
        //是否遗体捐赠
        res.result.isDonate =
          res.result.isDonate == null ? "" : String(res.result.isDonate);
        //既往病史
        if (res.result.psHistory != null || "" || undefined) {
          var psHistory = res.result.psHistory.split("-");
          var psHistoryList = [];
          var diseaseother = ""; //by guo 2019-12-24-13:20添加
          //通过判断 处理其他显示为undefined的bug
          psHistory.forEach((item, index) => {
            if (item != "" && item != undefined && item != null) {
              //by guo 2019-12-24-13:50 item不为"" undefined  null
              switch (index) {
                case 0:
                  if (item == 1) {
                    psHistoryList.push("1");
                  }
                  break;
                case 1:
                  if (item == 1) {
                    psHistoryList.push("2");
                  }
                  break;
                case 2:
                  if (item == 1) {
                    psHistoryList.push("3");
                  }
                  break;
                case 3:
                  if (item == 1) {
                    psHistoryList.push("4");
                  }
                  break;
                case 4:
                  if (item == 1) {
                    psHistoryList.push("5");
                  }
                  break;
                // case 5:
                //   if (item == 1) {
                //     psHistoryList.push("6");
                //   }
                //   break;
                // case 6:
                //   if (item == 1) {
                //     psHistoryList.push("7");
                //   }
                //   break;
                //by guo 2019-12-24-13:30 修改  下面的case 7注释掉  显示会有bug   因为split这个分割字符串的方法 如果后面的数据中含有"-", split也会将其分割为独立的，导致显示不合
                default:
                  //判断一下   当为0时就显示为空字符串
                  if (item == 0) {
                    diseaseother = "";
                  } else {
                    //将数据用"-"拼接起来  如果是最后一位就不添加"-""
                    if (item != undefined && item != null && item != "") {
                      if (index == psHistory.length - 1) {
                        diseaseother += item;
                      } else {
                        diseaseother += item + "-";
                      }
                    } else {
                      diseaseother = "";
                    }
                  }
                  break;
                //by guo 2019-12-24-13:51 有bug  注释掉 已换成上面的default去判断
                // case 7:
                //   //by guo 2019-12-22-21:39 修改  将为0的直接置为空字符串
                //   // res.result.diseaseother=item;
                //   res.result.diseaseother=item==0 ? '' : item;
                //   break;
              }
            }
          });
          res.result.psHistory = psHistoryList;
          res.result.diseaseother = diseaseother; //by guo 2019-12-24-13:51添加

        } else {
          res.result.psHistory = [];
        }

        //特殊饮食要求
        if (res.result.specialDiet != null || "" || undefined) {
          var specialDiet = res.result.specialDiet.split("-");
          var specialDietList = [];
          var otherDiet = ""; //by guo 2019-12-24-13:20添加
          //通过判断 处理其他显示为undefined的bug
          specialDiet.forEach((item, index) => {
            if (item != "" && item != undefined && item != null) {
              //by guo 2019-12-24-13:50 item不为"" undefined  null
              switch (index) {
                case 0:
                  if (item == 1) {
                    specialDietList.push("1");
                  }
                  break;
                case 1:
                  if (item == 1) {
                    specialDietList.push("2");
                  }
                  break;
                case 2:
                  if (item == 1) {
                    specialDietList.push("3");
                  }
                  break;
                case 3:
                  if (item == 1) {
                    specialDietList.push("4");
                  }
                  break;
                case 4:
                  if (item == 1) {
                    specialDietList.push("5");
                  }
                  break;
                case 5:
                  if (item == 1) {
                    specialDietList.push("6");
                  }
                  break;
                case 6:
                  if (item == 1) {
                    specialDietList.push("7");
                  }
                  break;
                //by guo 2019-12-24-13:30 修改  下面的case 7注释掉  显示会有bug   因为split这个分割字符串的方法 如果后面的数据中含有"-", split也会将其分割为独立的，导致显示不合
                default:
                  //判断一下   当为0时就显示为空字符串
                  if (item == 0) {
                    otherDiet = "";
                  } else {
                    //将数据用"-"拼接起来  如果是最后一位就不添加"-""
                    if (item != undefined && item != null && item != "") {
                      if (index == specialDiet.length - 1) {
                        otherDiet += item;
                      } else {
                        otherDiet += item + "-";
                      }
                    } else {
                      otherDiet = "";
                    }
                  }
                  break;
              }
            }
          });
          res.result.specialDiet = specialDietList;
          res.result.otherDiet = otherDiet; //by guo 2019-12-24-13:51添加

          // //通过判断 处理其他显示为undefined的bug
          // if(specialDiet[specialDiet.length-1]!=1 && specialDiet[specialDiet.length-1]!=2 && specialDiet[specialDiet.length-1]!=3 && specialDiet[specialDiet.length-1]!=4 && specialDiet[specialDiet.length-1]!=5 && specialDiet[specialDiet.length-1]!=6 && specialDiet[specialDiet.length-1]!=7){
          //   res.result.otherDiet=specialDiet[specialDiet.length-1];//取数组最后一项
          //   specialDiet.pop();//删除数组最后一项
          //   res.result.specialDiet=specialDiet
          // }else{
          //   res.result.specialDiet=specialDiet;
          //   res.result.otherDiet="";
          // }
        } else {
          res.result.specialDiet = [];
        }
        //人员类别
        var peopleType = []; //存人员类别的id
        // res.result.peopleType
        this.personReduceOptions.forEach(item => {
          if (res.result.peopleType == item.id) {
            res.result.peopleType = item.id;
            this.userTypeNameText = item.userTypeName; //需要判断人员类别
          }
          this.issleepy =
            this.userTypeNameText == "政府供养特困对象" ? true : false; //申请人情况隐藏
          peopleType.push(item.id);
        });
        if(this.userTypeNameText == '' &&  this.personReduceOptions != null){
          if(this.personReduceOptions[this.personReduceOptions.length-1]!=null){
            res.result.peopleType = this.personReduceOptions[this.personReduceOptions.length-1].id;
            this.userTypeNameText = this.personReduceOptions[this.personReduceOptions.length-1].userTypeName;
          }
        }
        let hospitalType = sessionStorage.getItem("hospitalType");
        if (this.hospitalStatus != -1 && hospitalType != 1) {
          //人员类别的下拉框是否可以选取  null---未入院  2---入院  by guo 2019-11-18-16:12 修改  考虑到其他机构已经入院的老人  录入身份证回显的问题
          //if(this.hospitalStatus!=-1){//人员类别的下拉框是否可以选取  null---未入院  2---入院
          this.peopleTypeDisabled = true;
        } else {
          this.peopleTypeDisabled = false;
        }
        //用于解决 已存在的其他机构的身份证的回显  导致人员类别id不存在导致下拉框数据回显错误的问题
        res.result.peopleType =
          peopleType.indexOf(res.result.peopleType) == -1
            ? ""
            : res.result.peopleType;
        //申请人情况    人员类别是政府供养特困对象时  因为页面的申请人情况隐藏了  为了接口兼容社区版  前面提交一个默认的字段给后端 这里需要处理隐藏
        this.personReduceOptions.forEach(item => {
          if (
            res.result.peopleType == item.userTypeCode &&
            item.userTypeName == "政府供养特困对象"
          ) {
            this.userTypeNameText = item.userTypeName; //提交的时候需要判断人员类别
          }
        });

        if (this.userTypeNameText == "政府供养特困对象") {
          if (this.oldmanId == null) {
            res.result.egNamea = "";
            res.result.egSex = "";
            res.result.egaIdCard = "";
            res.result.egaAddress = "";
            res.result.egPhonea = "";
            res.result.relationshipa = "";
          }
        }
        //特殊说明  需要将后台返回的String类型数据转换成Number类型的 否则无法回显
        if (res.result.specialCase != null || "" || undefined) {
          var specialCase = res.result.specialCase.split("-");
          res.result.outactivity = specialCase[0]!=' '?Number(specialCase[0]):'';
          res.result.room = specialCase[1]!=' '?Number(specialCase[1]):'';
          res.result.isHospitol = specialCase[2]!=' '?Number(specialCase[2]):'';
          res.result.dissother = specialCase[3]!=' '?Number(specialCase[3]):'';
        }
        //身份证截图的回显数据处理
        if (res.result.idCardPic != null || "" || undefined) {
          res.result.idCardPic = res.result.idCardPic.split(",");
          this.getMultiImgInfo(res.result.idCardPic, 1);
        } else {
          res.result.idCardPic = [];
        }
        //出院小结截图的回显数据处理
        if (res.result.outPic != null || "" || undefined) {
          res.result.outPic = res.result.outPic.split(",");
          this.getMultiImgInfo(res.result.outPic, 2);
        } else {
          res.result.outPic = [];
        }
        //其他截图的回显数据处理
        if (res.result.otherPic != null || "" || undefined) {
          res.result.otherPic = res.result.otherPic.split(",");
          this.getMultiImgInfo(res.result.otherPic, 3);
        } else {
          res.result.otherPic = [];
        }
        this.olderBaseDetailBean = res.result;
        if (this.olderBaseDetailBean.headPic) {
          this.getImgInfo(this.olderBaseDetailBean.headPic);
        }
      });
    },

    /**
     * 去除对象中所有符合条件的对象
     * @param {Object} obj 来源对象
     * @param {Function} fn 函数验证每个字段
     */
    compactObj(obj, fn) {
      for (var i in obj) {
        if (typeof obj[i] === "object") {
          this.compactObj(obj[i], fn);
        }
        if (fn(obj[i])) {
          delete obj[i];
        }
      }
    },

    /*
     *
     *
     * 删除空对象 删除'', null, undefined
     */
    isEmpty(object) {
      if (typeof object === "object") {
        for (var i in object) {
          return false;
        }
        return true;
      } else {
        return object === "" || object === null || object === undefined;
      }
    },

    /*
     *by guo 2019-11-26-11:46添加
     *校验不能输入特殊字符
     *
     */
    checkSpecialKey(str) {
      var specialKey =
        "[`~!#$^&*()-=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
      for (var i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false;
        }
      }
      return true;
    },

    /*
      在该页面防止浏览器点击后退按钮
    */
    fobiddenBack() {
      //防止页面后退
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", function() {
        history.pushState(null, null, document.URL);
      });
      window.addEventListener(
        "keydown",
        function(e) {
          //Ctrl+R ---刷新   F5 ---刷新   Ctrl+F5 ---强制刷新
          //(event.ctrlKey == true && k == 82) || (k == 116) || (event.ctrlKey == true && k == 116)
          if (
            e.keyCode == 32 ||
            (e.ctrlKey == true && e.keyCode == 82) ||
            e.keyCode == 116 ||
            (e.ctrlKey == true && e.keyCode == 116)
          ) {
            e.preventDefault();
            e.cancelBubble = false;
            e.returnValue = false;
            return false;
            //要做的其他事情
          }
        },
        false
      );
      window.onbeforeunload = function() {
        window.event.returnValue = "阻止";
      };
    }
  },
  created() {
    this.oldmanId = sessionStorage.getItem("editOldmanId"); //获取老人的id
    this.isPayed = sessionStorage.getItem("isPayed"); //获取是否缴费  0----未缴   1-----已缴
    if (sessionStorage.getItem("status")) {
      //by guo 2019-09-26 14:38 修改  判断是否存在
      this.hospitalStatus = sessionStorage.getItem("status"); //null----未入院  2----入院
    }
  },
  activated(){
    let oldmanId = sessionStorage.getItem("editOldmanId"); //获取老人的id
    console.log("this oldmanId: "+this.oldmanId);
    console.log("oldmanId: "+oldmanId);
    
    if(this.oldmanId != oldmanId){
      var hospitalType = sessionStorage.getItem("hospitalType","");
      if(oldmanId == null){
        this.oldmanId = null;
        this.olderBaseDetailBean = {
          psHistory: [], //既往病史
          specialDiet: [], //特殊饮食要求
        };
        this.$refs.olderBaseDetailBean.resetFields();
        this.idCardFileList = [];
        this.outFileList = [];
        this.otherFileList = [];
      }else{
        this.oldmanId = oldmanId * 1;
      }
      if(hospitalType == 3){
      //从咨询进入的
        let zixunRow = sessionStorage.getItem("zixunRow");
        sessionStorage.removeItem("zixunRow");
        sessionStorage.removeItem("hospitalType");
        let olamanRow = JSON.parse(zixunRow);
        this.olderBaseDetailBean.oldName = olamanRow.oldName;
        this.olderBaseDetailBean.oldAddress = olamanRow.address;
        this.olderBaseDetailBean.sex = String(olamanRow.oldSex);
        this.olderBaseDetailBean.egNamea = olamanRow.advisoryName;
        this.olderBaseDetailBean.egPhone = olamanRow.advisoryPhone;
        this.olderBaseDetailBean.advisoryId = olamanRow.id; //咨询记录的id
      }
      this.queryPersonCategory();
    }
  },
  mounted() {
    //入院咨询传过来的值
    var hospitalType = sessionStorage.getItem("hospitalType","");
    this.oldmanId = sessionStorage.getItem("editOldmanId"); //获取老人的id
    if(hospitalType == 3){
      //从咨询进入的
      let zixunRow = sessionStorage.getItem("zixunRow");
      sessionStorage.removeItem("zixunRow");
      sessionStorage.removeItem("hospitalType");
      let olamanRow = JSON.parse(zixunRow);
      this.olderBaseDetailBean.oldName = olamanRow.oldName;
      this.olderBaseDetailBean.oldAddress = olamanRow.address;
      this.olderBaseDetailBean.sex = String(olamanRow.oldSex);
      this.olderBaseDetailBean.egNamea = olamanRow.advisoryName;
      this.olderBaseDetailBean.egPhone = olamanRow.advisoryPhone;
      this.olderBaseDetailBean.advisoryId = olamanRow.id; //咨询记录的id
    }
    const that = this;
    window.screenWidth = document.body.clientWidth;
    that.bigWidth = (window.screenWidth * 9) / 24 + 200;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.bigWidth = (window.screenWidth * 9) / 24 + 200;
      })();
    };
    this.fobiddenBack();
    this.queryPersonCategory();
  },
  destroyed() {
    //最后不要忘了删除传输事件
    bus.$off("admissiondetail");
  },
};
</script>
<style lang="scss" scoped>
.step ::v-deep .el-step__title {
  margin-left: -28px;
}
.step ::v-deep .el-step__icon-inner[class*="el-icon"]:not(.is-status) {
  font-size: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
}
.headPic {
  margin-left: 50px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: 300;
}

.itemminwidth {
  width: 250px;
}

.itemlarwidth {
  width: 300px;
}

.marginten {
  margin-top: 30px;
  padding-left: 10px;
  margin-bottom: 20px;
}
.radiogroup {
  height: 40px;
  line-height: 50px;
}

.elImage {
  width: 90%;
  height: 90%;
  margin: 10px 30px;
}

.footer {
 padding: 30px 0;
    background: #fff;
}

::v-deep .el-form-item__content_psHistory .el-form-item__content {
  height: 40px !important;
  line-height: 40px !important;
}

::v-deep .el-form-item__content_specialDiet .el-form-item__content {
  height: 40px !important;
  line-height: 40px !important;
}

.judgement ::v-deep .el-form-item{
  height: 30px !important;
  line-height: 30px !important;
  margin-bottom:0px;
}

</style>
